<template>
    <BaseWidget :title="widget.title" :footer="widget.footer">
        <ul v-for="person in widget.content.first" class="text-sm" :key="person.link">
            <li>
                <span v-if="person.is_birthday">🎂</span>
                <a :href="person.link">{{ person.full_name }}</a>
                <span class="ml-1 text-gray-600">
                    (
                    <span v-if="person.age"> {{ person.age }} {{ $tc('messages.years', 2) }}, </span>
                    <span>
                        {{ person.month_day }}
                    </span>
                    )
                </span>
            </li>
        </ul>
        <button type="button" @click="show = true" v-if="widget.content.diff > 0">
            <span class="text-xs text-indigo-600">
                {{
                    $tc('messages.and_X_more', widget.content.diff, {
                        x: widget.content.diff,
                    })
                }}
            </span>

            <SlideOver :show="show" @close="show = false">
                <div v-for="day in widget.content.days" :key="day.simple_readable_date">
                    <span class="mt-5 font-bold">{{ day.simple_readable_date }}</span>
                    <ul class="ml-3">
                        <li v-for="person in day.people" :key="person.link">
                            <span v-if="person.is_birthday">🎂</span>
                            <a :href="person.link">{{ person.full_name }}</a>
                            <span class="ml-1 text-gray-600">
                                (
                                <span v-if="person.age">
                                    {{ person.age }}
                                    {{ $tc('messages.years', 2) }},
                                </span>
                                <span>
                                    {{ person.month_day }}
                                </span>
                                )
                            </span>
                        </li>
                    </ul>
                </div>
            </SlideOver>
        </button>
    </BaseWidget>
</template>

<script>
import BaseWidget from '@/components/Widgets/BaseWidget.vue';
import SlideOver from '@/components/SlideOver.vue';

export default {
    name: 'BirthdaysWidget',
    components: {
        BaseWidget,
        SlideOver,
    },
    props: {
        widget: {
            required: true,
            type: Object,
        },
    },
    data() {
        return {
            show: false,
        };
    },
};
</script>
